import { Group } from 'src/design/atoms/Group';
import { LoadingOverlay } from 'src/design/atoms/LoadingOverlay';
import { Paper } from 'src/design/atoms/Paper';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { useEmails } from 'src/api/queries/emails/useEmails';
import { useJobs } from 'src/hooks/useJobs';
import { Header } from 'src/design/organisms/Header';
import { EmailList } from './EmailList';

export const Emails: React.FC = () => {
  const { selectedJob } = useJobs();
  const { data: emails, isLoading } = useEmails(selectedJob?.jobNumber);

  return (
    <>
      <Header
        title="Emails"
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            { text: 'Emails' },
          ],
        }}
        helpText="View and manage emails for this job"
      />

      <Paper pos="relative" mt="md">
        <LoadingOverlay visible={isLoading} />
        {!isLoading && (emails?.length ?? 0) === 0 && (
          <Group justify="center">
            <Text>No emails found</Text>
          </Group>
        )}
        <EmailList emails={emails ?? []} />
      </Paper>
    </>
  );
};
